<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px;">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}}: {{accion.accion}}</h3>
                </header>
            </section>
            <section class="widget">
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                        <inputCustom [titulo]="'Ciclo'" [disabled]="true" [(ngModel)]="entidad.ciclo" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                        <inputCustom [titulo]="'Nombre del periodo de evaluación'" [disabled]="true" [(ngModel)]="entidad.descripcion" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                        <inputCustom [titulo]="'Tipo de evaluación'" [disabled]="true" [(ngModel)]="accion.accion" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                        <inputCustom [titulo]="'Nivel'" [disabled]="true" [(ngModel)]="accion.entidad.nivel" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                </div>

                <dx-tab-panel #tab preserveContent mat-stretch-tabs [animationEnabled]="true" [height]="800">
                    <dxi-item title="Alumnos">
                        <asignacionevaluaciontaller_alumno #general
                        [nivelid]="accion.entidad.nivelid"
                        [periodoevaluacionportipoevaluacionid]="accion.entidad.periodoevaluacionportipoevaluacionid"
                        [periodoevaluacionid]="entidad.periodoevaluacionid"
                        [identificador]="identificador"
                        (salir)="Salir()">
                    </asignacionevaluaciontaller_alumno>
                </dxi-item>
                <dxi-item title="Padres de familia">
                  <div></div>
                    <asignacionevaluaciontaller_padre #secundario
                    [periodoevaluacionportipoevaluacionid]="accion.entidad.periodoevaluacionportipoevaluacionid"
                    [periodoevaluacionid]="entidad.periodoevaluacionid"
                    [nivelid]="accion.entidad.nivelid"
                    [identificador]="identificador">
                        </asignacionevaluaciontaller_padre>
                    </dxi-item>
                </dx-tab-panel>

                <div class="divisor20"></div>
                <div class="row margen" >
                    <div class="col-12">
                        <div class="panelBotonesFiltro">
                            <button matTooltip="Cancelar" class="boton botonSM filledBlanco"
                            (click)="Salir()">
                            <span> {{'Cancelar'}}</span>
                        </button>
                            <div class="divisorH16 " ></div>
                            <button matTooltip="Guardar" class="boton botonSM filled" [class.disabled]="visualizar"
                            (click)="Guardar()"
                            *ngIf="sistemaService.permisos.agregar">
                            <span> {{'Guardar'}}</span>
                        </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>

<div #asignacionevaluaciontalleralumno></div>
<div #asignacionevaluaciontallerpadre></div>
